import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { PostOrderList } from "./ui/organisms/PostOrderList";
// import { PlanOverview } from "./ui/molecules/PlanOverview/Index";
import { Overview } from "./ui/molecules/Overview";
import { ChannelOrderList } from "./ui/organisms/ChannelOrderList";
import { useLocation, useNavigate } from "react-router-dom";
import { Balance } from "../plan/ui/molecules/Balance";
import { CurrentPriceOverview } from "./ui/molecules/CurrentPriceOverview";
import { useTranslation } from "react-i18next";

export const FastViews = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const location = useLocation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tabValue = useMemo(
    () => new URLSearchParams(location.search).get("tab") || "posts",
    [location.search]
  );

  const setTabFunc = (value: string) => {
    if (value === "posts") {
      return 0;
    }
    if (value === "channels") {
      return 1;
    }
    return 0;
  };

  const [tab, setTab] = useState<number>(setTabFunc(tabValue));

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) {
      navigate("/fast-views/orders?tab=posts");
    }
    if (newValue === 1) {
      navigate("/fast-views/orders?tab=channels");
    }
  };

  useEffect(() => {
    setTab(setTabFunc(tabValue));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    // <Box sx={{ maxWidth: "1440px", width: "100%" }}>
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          mr: "24px",
        }}
      >
        <Overview />
        <CurrentPriceOverview />
        <Balance />
        {/* <PlanOverview /> */}
      </Box>

      <Box
        sx={{
          // maxWidth: "1440px",
          width: "100%",
          boxShadow:
            "rgba(0, 0, 0, 0.04) 0px 5px 22px, rgba(0, 0, 0, 0.03) 0px 0px 0px 0.5px",
          borderRadius: "16px",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tab}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label={t("posts.posts")} {...a11yProps(0)} />
            <Tab label={t("channels.channels")} {...a11yProps(1)} />
          </Tabs>
        </Box>

        {tab === 0 && <PostOrderList />}
        {tab === 1 && <ChannelOrderList />}
      </Box>
    </Box>
  );
};
